<template>
  <div class="policy-detail-page">
    <!-- 顶部横幅部分 -->
    <div class="section-banner"></div>

    <!-- 详情内容部分 -->
    <div class="detail-container">
      <div class="detail-card">
        <h2 class="detail-title">{{ policyDetail.title }}</h2>
        <div class="detail-date">{{ policyDetail.pubtime }}</div>
        <div class="detail-content" v-html="policyDetail.content"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { getPolicyDetailApi } from '@/api/index';

export default {
  name: 'PolicyDetail',
  data() {
    return {
      policyDetail: {},
      loading: false,
      id: null
    }
  },
  created() {
    // 从路由获取政策ID
    this.id = this.$route.params.id;
    if (this.id) {
      this.getPolicyDetail();
    }
  },
  methods: {
    async getPolicyDetail() {
      try {
        this.loading = true;
        const res = await getPolicyDetailApi(this.id);
        if (res && res.data) {
          this.policyDetail = res.data;
        } else {
          this.$message.error('获取政策详情失败');
        }
      } catch (error) {
        console.error('获取政策详情出错', error);
        this.$message.error('获取政策详情失败');
      } finally {
        this.loading = false;
      }
    }
  }
}
</script>

<style scoped lang="scss">
.policy-detail-page {
  width: 100%;
  color: #333;
}

// 顶部横幅
.section-banner {
  height: 400px;
  background-image: url('https://echance.oss-cn-beijing.aliyuncs.com/news-bg.png');
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  color: #fff;
}

// 详情内容
.detail-container {
  width: 1200px;
  margin: -80px auto 60px;
  position: relative;

  .detail-card {
    background-color: #fff;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
    padding: 40px 60px;
    border-radius: 4px;

    .detail-title {
      font-weight: bold;
      font-size: 28px;
      color: #333;
      text-align: center;
      margin-bottom: 20px;
    }

    .detail-date {
      font-size: 14px;
      color: #999;
      text-align: center;
      margin-bottom: 40px;
    }

    .detail-content {
      font-size: 16px;
      line-height: 1.8;
      color: #333;

      p {
        margin-bottom: 20px;
      }

      .signature {
        text-align: right;
        margin-top: 40px;
        margin-bottom: 5px;
      }

      .signature-date {
        text-align: right;
        margin-top: 0;
      }
    }
  }
}
</style>